import './SingleCard.css'

export default function ActionCard({ card, handleActionSelection }) {
	const handleClick = () => {
		if (!card.disabled) {
			handleActionSelection(card)
		}
	}
	let smallCard
	if (card.type === 'heal' || card.type === 'magic') {
		smallCard = true
	}

	return (
		<div className={card.disabled ? 'card disabled' : 'card'}>
			<div className={smallCard ? 'flipped small' : 'flipped'}>
				<img className='front' src={card.src} alt='card front' onClick={handleClick} />
			</div>
		</div>
	)
}
